export default "__VITE_ASSET__bc7d193a__"